import { SelectOptionGroup } from "web/data/models"
import React from "react"
import { getRandomInt } from "./utils"
import { dataTest } from './test-utils'

/**
 * Creates JSX elements from an optiongroup list
 */
export function createGroupedOptions({
    optionGroups,
    onlyIncludeSelectable
}: {
    optionGroups: SelectOptionGroup[]
    /**
     * If present and true, only groups that are listed as selectable
     * will be included.
     */
    onlyIncludeSelectable?: boolean
}): JSX.Element[] {

    return optionGroups
        .filter((grp) => {
            if (onlyIncludeSelectable !== true) {
                return true
            }

            return grp.isSelectable
        })
        .map(entry => {
            return (
                <optgroup
                    key={entry.label}
                    label={entry.label}
                >

                    {entry.items.map(item => {
                        return (
                            <option
                                data-test={dataTest('select-option', item.label)}
                                key={item.value}
                                value={item.value}
                            >
                                {item.label}
                            </option>
                        )
                    })}

                </optgroup>
            )
        })

}

/**
 * Helpful for mocking list elements
 */
export function genRandomElementCount(min: number, max: number, genFn: () => JSX.Element): JSX.Element[] {
    const amount = getRandomInt(min, max)
    const output: JSX.Element[] = []

    for (let index = 0; index < amount; index++) {
        output.push(genFn())
    }

    return output
}

export function setFocusToRef(ref: React.RefObject<HTMLElement>) {
    if (ref.current?.focus) {
        ref.current?.focus()
    } else {
        console.warn('Tried to focus on an element without a focus function')
    }
}
